import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { InfoPageComponent } from './pages/info-page/info-page.component';
import { StartGuard } from './core/guards/start.guard';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { MainGuard } from './core/guards/main.guard';
import { RoleGuard } from './core/guards/role.guard';
import { ClientGuard } from './core/guards/client.guard';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback.component';
import { APP_ROUTES, generatePlanningRoute } from './common/constants';
import { InspectionReportDownloadComponent } from './pages/inspection-report-download/inspection-report-download.component';
import { AuthGuard } from './core/guards/auth.guard';

export const AppRoutes: Routes = [
  { path: '', redirectTo: APP_ROUTES.AUTH.CALLBACK, pathMatch: 'full' },

  { path: APP_ROUTES.AUTH.CALLBACK, component: AuthCallbackComponent },
  { path: APP_ROUTES.MAIN, component: LandingPageComponent, canActivate: [MainGuard] },

  {
    path: APP_ROUTES.AUTH.NOT_APPROVED,
    component: InfoPageComponent,
    data: { title: 'Need Approval!' },
  },

  {
    path: generatePlanningRoute(APP_ROUTES.PLANNING.INSPECTION_REPORT_DOWNLOAD).replace(/^\//, ''),
    component: InspectionReportDownloadComponent,
    canActivate: [RoleGuard, AuthGuard],
  },

  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [StartGuard],
    children: [
      {
        path: APP_ROUTES.PLANNING.BASE,
        loadChildren: () =>
          import('./layouts/app-planning/plan-inspections.module').then(
            (m) => m.PlanInspectionsModule
          ),
        canActivate: [RoleGuard],
      },
      {
        path: APP_ROUTES.USER.BASE,
        loadChildren: () => import('./layouts/app-user/user.module').then((m) => m.UserModule),
        canActivate: [RoleGuard],
      },
      {
        path: '',
        loadChildren: () =>
          import('./layouts/client-module/client-module.module').then((m) => m.ClientModuleModule),
        canActivate: [ClientGuard],
      },
    ],
  },

  { path: '**', redirectTo: APP_ROUTES.MAIN },
];
